// extracted by mini-css-extract-plugin
export default {"root":"style_root__ti56g","popper":"style_popper__6xr4R"};